module.exports = __webpack_public_path__ + "static/media/right.bc1119dc.mp3";